module.exports = __webpack_public_path__ + "ec2b6945943533ff55fe72dd5e1a034e.svg";